import { useCallback } from "react";
import { Col, Card } from "antd";
import dayjs from "dayjs";

import { Maybe } from "graphql/generated/graphql";
import { type GetDistinctFilteredInstalledProductsQuery as iDeviceQueryType } from "graphql/queries/get-distinct-filtered-installed-products.generated";
import routeNames from "constants/route-names";
import { useNavigate } from "react-router-dom";
import StructuredLocation from "components/structured-location/structured-location";
import { labelsFromRelationships } from "utils/location-hierarchy";

interface InstalledProductCardProps {
	product: iDeviceQueryType["installed_products"][number]["product"];
	installed_product: iDeviceQueryType["installed_products"][number];
	property: iDeviceQueryType["installed_products"][number]["property"];
	installation_date?: any;
	location?: Maybe<string>;
	productQuantity?: number;
	device_status?: Maybe<string>;
	property_count: number;
	arePropertiesFiltered: boolean;
}

const InstalledProductCard: React.FC<InstalledProductCardProps> = (props: InstalledProductCardProps) => {
	const navigate = useNavigate();
	const {
		product,
		installed_product,
		property,
		installation_date,
		location,
		device_status,
		property_count,
		arePropertiesFiltered
	} = props;

	const { photo_link = "", name, installed_products_aggregate } = product;

	const productCount = installed_products_aggregate?.aggregate?.count || 1;
	const imageSrc = installed_product.photo_link || photo_link;
	const isSingleProduct = productCount === 1 && property_count === 1;

	const handleOnClickProduct = useCallback(() => {
		if (isSingleProduct) {
			navigate(routeNames.INSTALLED_DEVICES_DETAILS.replace(":installedDevId", installed_product.id));
		} else {
			navigate(routeNames.INSTALLED_DEVICE_DETAILS.replace(":deviceId", product.id));
		}
	}, [isSingleProduct, installed_product.id, product.id]);

	return (
		<Col>
			<Card hoverable bordered={false} className="product-card" onClick={handleOnClickProduct}>
				{imageSrc ? (
					<img alt={name} src={imageSrc} className={`product-image`} />
				) : (
					<div className={`product-image`}>
						<img
							alt={name}
							src={`${process.env.PUBLIC_URL}/assets/images/icons/product-placeholder.svg`}
							className={`product-image-placeholder`}
						/>
					</div>
				)}

				<div className="product-title">
					<div className="product-title-container">
						<span className="product-name">{name}</span>
					</div>
				</div>

				<div className="product-card-space">
					{/* <div>
            {/online|offline/.test(String(device_status)) && (
              <span className={`product-device-status-${device_status}`}>
                {device_status}
              </span>
            )}
          </div> */}
					{isSingleProduct ? (
						<>
							<span className="product-description">{property?.name}</span>
							<StructuredLocation labels={labelsFromRelationships(installed_product)} />
							<span className="product-location">{location}</span>
							<div className="installed-product-single-details">
								<span className="product-description">
									{`Installed ${dayjs(installation_date).format("MM/DD/YYYY")}`}
								</span>
							</div>
						</>
					) : (
						<span className="product-description">
							{arePropertiesFiltered && property_count === 1
								? `${productCount} locations`
								: `${productCount} at ${property_count} ${property_count > 1 ? "properties" : "property"}`}
						</span>
					)}
				</div>
			</Card>
		</Col>
	);
};

export default InstalledProductCard;
